import React from 'react';
import PropTypes from 'prop-types';
import {Alert, FlashMessage} from '@tenancy.nz/design-system';

function Message({flash, text, onClose, type, show}) {
  return (
    <>
      {flash && (
        <FlashMessage color={type} open={show} onClose={onClose}>
          {text}
        </FlashMessage>
      )}
      {!flash && show && (
        <Alert color={type} variant="standard" onClose={onClose}>
          {text}
        </Alert>
      )}
    </>
  );
}

Message.propTypes = {
  /**
   * If true, will show a message and the message box will disappear after few seconds
   */
  flash: PropTypes.bool,

  /**
   * The message to display
   */
  text: PropTypes.node.isRequired,

  /**
   * Callback function to call after close event is completed.
   */
  onClose: PropTypes.func,

  /**
   * Typically the color of the message box.
   */
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * If `true`, message box will be visible.
   */
  show: PropTypes.bool,
};

Message.defaultProps = {
  flash: false,
  onClose: undefined,
  type: 'error',
  show: false,
};

export default Message;
